export default __webpack_public_path__ + "static/media/logo.7bddfbc4.png";